import React from 'react';
import { Grid, Typography, Avatar, Box, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
    quoteSection: {
        padding: '10px 60px 0px 60px', //Top Right Bottom Left
        [theme.breakpoints.down('md')]: {padding: '0px 30px 0px 30px'},
        [theme.breakpoints.down(1000)]: {padding: '0px 15px 0px 15px'},
        [theme.breakpoints.down(801)]:  {padding: '0px 80px 0px 80px'},
        [theme.breakpoints.down('xs')]: {padding: '0px 20px 0px 20px'},
        [theme.breakpoints.down(460)]:  {padding: '0px  8px 0px  8px'},
        [theme.breakpoints.down(400)]:  {padding: '0px  5px 0px  5px'},
    },
    quoteParagraph: {        
        fontWeight: 500,
        //fontStyle: 'italic',
        color: theme.palette.text.secondary,
        alignContent: 'center',
        textAlign: 'left',
        lineBreak: 'loose',
        paddingBottom: '1rem',
        height: '90px', fontSize: '1.1rem',
        [theme.breakpoints.down('md')]: {height: '85px', fontSize: '1rem'},
        [theme.breakpoints.down(1100)]: {height: '80px', fontSize: '0.9rem'},
        [theme.breakpoints.down(801)]:  {height: '85px', fontSize: '1rem'},
        [theme.breakpoints.down(460)]:  {height: '85px', fontSize: '0.9rem'},
        [theme.breakpoints.down(400)]:  {height: '85px', fontSize: '0.85rem'},
    },
    quoteName: {
        color: theme.palette.primary.main,
        fontWeight: 600,
        textAlign: 'right',
        width: '100%',
        paddingTop: '10px',
        paddingRight: '5px',
        fontSize: '1.1rem', 
        [theme.breakpoints.down('md')]: {fontSize: '1rem'},
        [theme.breakpoints.down(1100)]: {fontSize: '0.95rem'},
        [theme.breakpoints.down(800)]:  {fontSize: '1rem'},
        [theme.breakpoints.down(460)]:  {fontSize: '0.85rem'},
        [theme.breakpoints.down(400)]:  {fontSize: '0.8rem'},
    },
    quoteBio: {
        color: theme.palette.primary.main,
        textAlign: 'right',
        width: '100%',
        paddingRight: '5px',
        fontSize: '1rem', 
        [theme.breakpoints.down('md')]: {fontSize: '0.9rem'},
        [theme.breakpoints.down(1100)]: {fontSize: '0.85rem'},
        [theme.breakpoints.down(800)]:  {fontSize: '0.9rem'},
        [theme.breakpoints.down(460)]:  {fontSize: '0.8rem'},
        [theme.breakpoints.down(400)]:  {fontSize: '0.75rem'},
    },
    circularAvatar: {
        width: 120, height: 120,
        [theme.breakpoints.down('md')]: {width: 90, height: 90,},
        [theme.breakpoints.down(1100)]: {width: 85, height: 85,},
        [theme.breakpoints.down(800)]:  {width: 90, height: 90,},
        [theme.breakpoints.down('xs')]: {width: 80, height: 80,},
        borderRadius: '50%',
        objectFit: 'cover',
    },
    kaiming:    {width: '200%', height: '200%', objectFit: 'cover', transform: 'translate(3%, 23%)'},      
    drlo:       {width: '100%', height: '100%', objectFit: 'cover', transform: 'translate(0%, 0%)'},      
    bensir:     {width: '95%',  height: '95%',  objectFit: 'cover', transform: 'translate(0%, 0%)'},      
    willng:     {width: '110%', height: '110%', objectFit: 'cover', transform: 'translate(0%, -3%)'},      
    meiyee:     {width: '115%', height: '115%', objectFit: 'cover', transform: 'translate(7%, 7%)'},      
    sabrina:    {width: '150%', height: '150%', objectFit: 'cover', transform: 'translate(-15%, 0%)'},      
    roger:      {width: '100%', height: '100%', objectFit: 'cover', transform: 'translate(0%, 0%)'},
    chris:      {width: '110%', height: '110%', objectFit: 'cover', transform: 'translate(-7%, 3%)'},
    winsome:    {width: '100%', height: '100%', objectFit: 'cover', transform: 'translate(0%, 0%)'},
    chiwang:    {width: '100%', height: '100%', objectFit: 'cover', transform: 'translate(0%, 0%)'},
    hugo:       {width: '200%', height: '200%', objectFit: 'cover', transform: 'translate(10%, 10%)'},
    laupo:      {width: '180%', height: '180%', objectFit: 'cover', transform: 'translate(0%, 0%)'},
    karen:      {width: '120%', height: '120%', objectFit: 'cover', transform: 'translate(0%, 5%)'},
    kimfan:     {width: '100%', height: '100%', objectFit: 'cover', transform: 'translate(0%, 0%)'},

    blockLine: {        
        height: '2px',
        width: '33%',
        maxWidth: '200px',
        backgroundColor: theme.palette.text.secondary,
        margin: '24px',
    },
    
}));

function QuoteItem({ image, quote, name, bio1, bio2, bio3, link }) {
    const classes = useStyles();
    const widthIsNarrow = useMediaQuery('(max-width: 800px)');
    
    return (
        <Grid container style={{ flexBasis: widthIsNarrow ? '100%' : '50%' }} className={classes.quoteSection} direction="column" alignItems="center">            
            <Typography className={classes.quoteParagraph}>{quote}</Typography>
            <Grid container alignItems="center" justifyContent="right" direction="row-reverse">
                <Grid item>
                    <Avatar className={classes.circularAvatar}>
                        <img
                            src={'/img/teacher/' + image + '.webp'}
                            className={classes[image]}
                            alt={name}
                            loading="lazy"
                            decoding="async"
                        />
                    </Avatar>
                </Grid>
                <Grid item>
                    <Link href={link}>
                        <Typography className={classes.quoteName}>{name}</Typography>
                        <Typography className={classes.quoteBio}>{bio1}</Typography>
                        <Typography className={classes.quoteBio}>{bio2}</Typography>
                        <Typography className={classes.quoteBio}>{bio3}</Typography>
                    </Link>
                </Grid>
            </Grid>
            <Box className={classes.blockLine} />
        </Grid>
    );
}
QuoteItem.propTypes = {
    image: PropTypes.string.isRequired,
    quote: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    bio1: PropTypes.string.isRequired,
    bio2: PropTypes.string.isRequired,
    bio3: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
};

export default QuoteItem;